import styled from 'styled-components';
import Input from 'sushiweb/InputTypes/Input';
import Button from 'sushiweb/Button';
import Layout from 'sushiweb/Layout';
import grey from 'sushiweb/tokens/color/grey';
import red from 'sushiweb/tokens/color/red';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 7.2rem;
  right: 0;
  width: calc(100vw - 27rem);
  min-height: calc(100vh - 7.2rem);
  background: #f5f6f8;
  padding: 3rem 2rem 10rem 2rem;
`;

export const PageHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.4rem;
  padding-bottom: 2rem;
  max-width: 1310px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const PageTitle = styled.h2`
  font-size: 2.4rem;
  font-weight: 700;
  color: ${grey.z900};
  margin: 0;
`;

export const PageSubtitle = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  color: ${grey.z600};
  margin: 0.4rem 0 0 0;
`;

export const SectionHeading = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${grey.z900};
  margin: 0 0 2rem 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

export const ContentContainer = styled.div`
  flex: 1;
  max-width: 1310px;
  width: 100%;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 1.2rem;
  border: 1px solid ${grey.z200};
  padding: 3.2rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
`;

export const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 27rem;
  right: 0;
  background: #fff;
  border-top: 1px solid ${grey.z200};
  padding: 1.6rem 2rem;
  z-index: 100;
`;

export const FullFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1310px;
  width: 100%;
  margin: 0 auto;
`;

export const ReviewActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

export const ReviewCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
  color: ${grey.z700};
`;

export const PolicyWrapper = styled.div`
  padding: 2rem 0;
`;

export const PolicyBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${grey.z50};
  border: 1px dashed ${grey.z300};
  border-radius: 0.8rem;
  padding: 4rem 2rem;
  gap: 1.6rem;
`;

export const PolicyDesc = styled.p`
  font-size: 1.4rem;
  color: ${grey.z600};
  text-align: center;
  margin: 0;
`;

export const PolicyListContainer = styled.div`
  padding: 2rem 0;
`;

export const PolicyHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const PolicyHeaderLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const PolicySeparator = styled.span`
  color: ${grey.z300};
  font-size: 1.4rem;
  padding: 0 0.4rem;
`;

export const PolicyItemContainer = styled.div`
  margin-bottom: 0;
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const SlotBudgetInputWrapper = styled(InputWrapper)`
  margin-top: 1.2rem;
`;

export const FormWrapper = styled.div`
  width: 100%;
`;

export const NeverEnd = styled.div`
  display: flex;
  align-items: flex-start;
`;

NeverEnd.Container = styled.div`
  display: flex;
  align-items: center;
`;

export const HelperTextWrapper = styled.div`
  font-size: 1.2rem;
  color: ${grey.z500};
  padding: 0.4rem 0;
`;

export const SlotHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 0 0.8rem 0;
  border-top: 1px solid ${grey.z200};
  margin-top: 1.6rem;
`;

export const InterPolicyHeader = styled.p`
  font-size: 1.4rem;
  color: ${grey.z600};
  margin: 1.2rem 0;
`;

export const StyledInput = styled(Input)`
  border-radius: 18px;
`;

export const StyledLayout = styled(Layout)`
  margin-bottom: 0;
`;

export const PolicyButton = styled(Button)`
  background: none;
  padding: 0;
  border: none;
  color: ${red.z500};

  &:hover {
    color: ${red.z600};
  }
`;

export const ErrorContainerV2 = styled.div`
  background: #fff3f3;
  border: 1px solid #ffcccc;
  border-radius: 0.6rem;
  padding: 1.2rem 1.6rem;
  margin-top: 1.6rem;

  p {
    margin: 0.4rem 0;
    font-size: 1.3rem;
    color: #d32f2f;
  }
`;

export const PolicyFormBody = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${grey.z200};
  padding: 1.6rem 2.4rem;
`;

export const PolicyFormFooter = styled.div`
  border-top: 1px solid ${grey.z200};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1.6rem 2.4rem;
`;

export const SlotRuleTitle = styled.div`
  font-weight: 500;
  font-size: 1.6rem;
`;

export const AmountInput = styled(Input)`
  border-radius: 18px;
  margin-top: 0;
  margin-bottom: 0;
  padding-bottom: 0;
  width: 100%;
`;

export const FrequencyBudgetRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.6rem;
  align-items: start;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const FrequencyBudgetField = styled.div`
  min-width: 0;
`;

export const BudgetInputField = styled(FrequencyBudgetField)`
  padding-top: 2.6rem;

  @media (max-width: 480px) {
    padding-top: 0;
  }
`;

export const DateTimeInput = styled(Input)`
  border-radius: 18px;
  margin-top: -5px;
`;

export const SpinnerCenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 4rem 0;
`;

export const ModalFormWrapper = styled.div`
  width: 70vw;
  max-width: 70rem;
  min-height: 45rem;
  background: #fff;
  border-radius: 0 0 16px 16px;
`;

export const CreateMealPlanButton = styled(Button)`
  min-width: 180px;
`;

NeverEnd.SlotContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
`;

NeverEnd.RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const FrequencyLabel = styled.span`
  display: block;
  padding: 0 0 0.8rem 0.4rem;
  font-size: 1.6rem;
  line-height: 1.8rem;
  font-weight: 600;
  color: #414a5d;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const FrequencyDropdownWrapper = styled.div`
  width: 100%;

  > div,
  > div > div {
    width: 100%;
  }

  > div > div > div:first-child span {
    line-height: 2.2rem;
  }
`;
